import { createBrowserRouter, Navigate } from "react-router-dom";
import { RegistrationPage } from "pages/RegistrationPage/RegistrationPage";
import { AccountPage } from "pages/AccountPage";
import { Layout } from "layouts/Layout/Layout";
import MoviePage from "../components/MovieList/MoviePage/MoviePage";
import { Homepage } from "../pages/Homepage";
import { CreateEvent } from "../pages/CreateEvent/CreateEvent";
import { OrganizerEventPage } from "../pages/OrganizerEventPage/EditEvent/OrganizerEventPage";
import { OrganizerPage } from "pages/OrganizerPage/OrganizerPage";
import { ScannerQR } from "../pages/OrganizerEventPage/ScannerQR/ScannerQR";
import { PersonDataConsentPage } from "pages/PersonDataConsentPage";
import { PaymentSuccessPage } from "../pages/PaymentSuccessPage/PaymentSuccessPage";
import { Information } from "../pages/Information/Information";
import { NotFoundPage } from "../pages/NotFoundPage/NotFoundPage";
import { EditEvent } from "../pages/EditEvent/EditEvent";
import { OrganizerEventPageSecond } from "../pages/OrganizerEventPage/OrganizerEventPageSecond";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        index: true, // Т. е. "/" — главная
        element: <Homepage />,
      },
      {
        path: "homePage", // Срабатывает ТОЛЬКО на "/homePage"
        element: <Homepage />,
      },
      {
        path: "registrationPage",
        element: <RegistrationPage />,
      },
      {
        path: "createEventPage",
        element: <CreateEvent />,
      },
      {
        path: "organizer_event/:id",
        element: <OrganizerEventPage />,
      },
      {
        path: "/edit_event/:id",
        element: <EditEvent />,
      },
      {
        path: "/organizer_event/:id/check_tickets",
        element: <OrganizerEventPageSecond />,
      },
      {
        path: "organizer_page/:id",
        element: <OrganizerPage />,
      },
      {
        path: "accountPage",
        element: <AccountPage />,
      },
      {
        path: "personDataConsent",
        element: <PersonDataConsentPage />,
      },
      {
        path: "event/:id",
        element: <MoviePage />,
      },
    ],
  },
  {
    path: "/organizer_event/:id/scanner",
    element: <ScannerQR />,
  },
  {
    path: "/order/:orderId",
    element: <PaymentSuccessPage />,
  },
  {
    path: "/information/refunds",
    element: <Information type="refunds" />,
  },
  {
    path: "/information/offer",
    element: <Information type="offer" />,
  },
  {
    path: "/404",
    element: <NotFoundPage />,
  },
  {
    path: "*",
    element: <Navigate to="/404" replace />,
  },
]);
